import { AccountNotFoundError } from "../../errors/account.js";
export const signTypedDataWith6492 = async (client, { account = client.account, typedData }) => {
    if (!account) {
        throw new AccountNotFoundError();
    }
    return account.signTypedDataWith6492(typedData);
};
//# sourceMappingURL=signTypedDataWith6492.js.map